<template>
    <nav>
      <OrdersPageFilterComponent
        :filters="filter"
        :show-delivery-options="true"
        :show-payment-options="true"
        @orders-page-filter:updated="onFilterUpdated"
      />
    </nav>

    <!-- Позиции заказов -->
    <OrderPositionsRegistry :filter="filter" :admin-mode="adminMode"/>
  </template>

  <script lang="ts">
  import OrdersPageFilterComponent from '@/domains/Orders/components/OrdersPage/OrdersPageFilter/OrdersPageFilterComponent.vue';
  import OrdersPageFilter          from '@/domains/Orders/components/OrdersPage/OrdersPageFilter/OrdersPageFilter';
  import OrderPositionsRegistry    from '@/domains/Orders/components/OrderPositionsRegistry/OrderPositionsRegistry.vue';

  export default defineComponent({
    name: 'OrdersPage',

    components: {
      OrdersPageFilterComponent,
      OrderPositionsRegistry,
    },

    props: {
      /**
       * Админский режим — админские колонки и isAdminMode на бэк.
       * Обычно Включается только из роутера (props: { adminMode: true }) для админского реестра.
       * При встраивании в воронки/карточки не указывается — реестр работает в регулярном режиме.
       */
      adminMode: {
        type:    Boolean as PropType<Boolean>,
        default: false,
      },
    },

    data() {
      return {
        filter: OrdersPageFilter.fromLocalStorage(),
      };
    },

    methods: {
      onFilterUpdated(newFilter: OrdersPageFilter) {
        this.filter = newFilter;
      },
    },
  });
  </script>
